import slugify from 'slugify';

export const personToPath = person => `/${slugify(person.name)}/${person.id}`;



// WEBPACK FOOTER //
// ./src/utils.js